export default "__VITE_ASSET__DzSCzUsk__"